import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CalendarInnerComponent } from './calendar-inner.component';
import { CalendarService } from './calendar.shared.service';

/* tslint:disable:component-selector-name component-selector-type */
@Component({
  selector: 'axis-calendar-container, [axis-calendar-container]',
  host: {
    class: 'axis-calendar'
  },
  template: `
    <axis-calendar-inner [activeDate]="activeDate"
                         [dateRange]="dateRange"
                         [startDate]="startDate"
                         [endDate]="endDate"
                         [modelDate]="modelDate"
                         [datepickerMode]="datepickerMode"
                         [browserLocale] = "browserLocale"
                         [selectOnDay]="selectOnDay"
                         [selectOnMonth]="selectOnMonth"
                         [selectOnYear]="selectOnYear"
                         (selectedRange)="onSelectRange($event)"
                      (selectionDone)="onSelectionDone($event)">
    </axis-calendar-inner>
    `
})
/* tslint:enable:component-selector-name component-selector-type */
export class CalendarComponent {
  /** currently active date */
  @Input()
  public get activeDate(): Date {
    return this._activeDate || this._now;
  }

  public set activeDate(value: Date) {
    this._activeDate = value;
  }
  @Input() public modelDate: Date;
  @Input() public dateRange = false;
  @Input() public startDate;
  @Input() public endDate;
  public browserLocale = false;
  public datepickerMode: string;
  public selectOnDay = false;
  public selectOnMonth = false;
  public selectOnYear = false;

  @Output()
  public selectionDone: EventEmitter<Date> = new EventEmitter<Date>(undefined);
  @Output()
  public selectedRange: EventEmitter<any> = new EventEmitter();
  @ViewChild(CalendarInnerComponent, { static: true })
  public _calendar: CalendarInnerComponent;


  public modelValue: Date;
  protected _now: Date = new Date();
  protected _activeDate: Date;

  public constructor(
    private calendarService: CalendarService,
  ) {
    this.configureOptions();
  }

  public configureOptions(): void {
    Object.assign(
      this,
      this.calendarService.getDatepickerInstance()
    );
  }
  public onSelectionDone(event: Date): void {
    this.selectionDone.emit(event);
  }

  public onSelectRange(event: Date): void {
    this.selectedRange.emit(event);
  }
}
